{
  "version": 1,
  "asset_id": "74da0f84-9457-4b86-ac7f-53e32cf4d1db",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/74da0f84-9457-4b86-ac7f-53e32cf4d1db/danny-main-logo-480.webp",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/74da0f84-9457-4b86-ac7f-53e32cf4d1db/danny-main-logo-480.webp",
  "original_filename": "danny-main-logo-480.webp",
  "size": 15764,
  "content_type": "image/webp",
  "created_at": "2026-07-17T19:00:13Z"
}
